import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FaTrash, FaPlus, FaBullhorn, FaEdit, FaSave, FaTimes } from 'react-icons/fa';

const ManageAnnouncementsPage = () => {
    const [announcements, setAnnouncements] = useState([]);
    const [title, setTitle] = useState('');
    const [content, setContent] = useState('');
    const [editingId, setEditingId] = useState(null); // Düzenlenen duyuru ID'si
    const [msg, setMsg] = useState(null);

    const API_URL = process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:5000/api';
    const getCleanToken = () => localStorage.getItem('token')?.replace(/"/g, '');

    const fetchAnnouncements = async () => {
        const token = getCleanToken();
        const { data } = await axios.get(`${API_URL}/extras/announcements`, { headers: { Authorization: `Bearer ${token}` } });
        setAnnouncements(data);
    };

    useEffect(() => { fetchAnnouncements(); }, []);

    // EKLEME VE GÜNCELLEME İŞLEMİ
    const handleSubmit = async (e) => {
        e.preventDefault();
        const token = getCleanToken();
        try {
            if (editingId) {
                // GÜNCELLEME (PUT isteği için POST tünelleme)
                // (Backend'de update route'u yoksa bunu eklememiz gerekebilir, şimdilik create mantığıyla devam ediyoruz)
                // Not: Duyuru güncelleme için Backend'e route eklemediysek, silip yenisini oluşturabiliriz ama
                // doğrusu güncelleme rotası eklemektir. Eğer rota yoksa aşağıda backend'e ekleyelim.
                await axios.post(`${API_URL}/extras/announcements/${editingId}?_method=PUT`, { title, content }, { headers: { Authorization: `Bearer ${token}` } });
                setMsg({ type: 'success', text: 'Duyuru güncellendi.' });
            } else {
                // YENİ EKLEME
                await axios.post(`${API_URL}/extras/announcements`, { title, content }, { headers: { Authorization: `Bearer ${token}` } });
                setMsg({ type: 'success', text: 'Duyuru eklendi.' });
            }
            
            setTitle(''); setContent(''); setEditingId(null);
            fetchAnnouncements();
        } catch (error) { setMsg({ type: 'error', text: 'İşlem başarısız.' }); }
    };

    const handleDelete = async (id) => {
        if(!window.confirm("Silinsin mi?")) return;
        const token = getCleanToken();
        try {
            await axios.post(`${API_URL}/extras/announcements/${id}?_method=DELETE`, {}, { headers: { Authorization: `Bearer ${token}` } });
            fetchAnnouncements();
        } catch (error) { alert('Silinemedi'); }
    };

    const startEdit = (ann) => {
        setEditingId(ann._id);
        setTitle(ann.title);
        setContent(ann.content);
    };

    const cancelEdit = () => {
        setEditingId(null);
        setTitle('');
        setContent('');
    };

    return (
        <div className="space-y-6 max-w-4xl mx-auto">
            <h1 className="text-2xl font-bold text-white mb-4">Duyuru Yönetimi</h1>
            
            {msg && <div className={`p-3 rounded border ${msg.type === 'success' ? 'bg-green-900 border-green-500 text-green-300' : 'bg-red-900 border-red-500 text-red-300'}`}>{msg.text}</div>}

            {/* FORM */}
            <form onSubmit={handleSubmit} className={`bg-surface border ${editingId ? 'border-yellow-500' : 'border-border'} p-6 rounded-xl space-y-4 shadow-lg transition-all`}>
                <div className="flex justify-between items-center">
                    <h3 className="text-white font-bold">{editingId ? 'Duyuruyu Düzenle' : 'Yeni Duyuru Ekle'}</h3>
                    {editingId && <button type="button" onClick={cancelEdit} className="text-xs text-red-400 hover:text-white flex items-center gap-1"><FaTimes/> İptal Et</button>}
                </div>
                
                <input type="text" placeholder="Başlık" value={title} onChange={e => setTitle(e.target.value)} className="w-full bg-background border border-border p-2 rounded text-white outline-none focus:border-primary" required />
                <textarea placeholder="İçerik..." value={content} onChange={e => setContent(e.target.value)} className="w-full bg-background border border-border p-2 rounded text-white outline-none h-24" required></textarea>
                
                <button type="submit" className={`w-full py-2 rounded font-bold transition-colors flex items-center justify-center gap-2 ${editingId ? 'bg-yellow-600 hover:bg-yellow-500 text-white' : 'bg-primary hover:bg-blue-600 text-white'}`}>
                    {editingId ? <><FaSave /> Değişiklikleri Kaydet</> : <><FaPlus /> Duyuru Yayınla</>}
                </button>
            </form>

            {/* LİSTE */}
            <div className="space-y-4">
                {announcements.map(ann => (
                    <div key={ann._id} className="bg-surface border border-border p-4 rounded-xl flex justify-between items-start group hover:border-gray-500 transition-colors">
                        <div>
                            <h3 className="font-bold text-white flex items-center gap-2 text-lg"><FaBullhorn className="text-primary"/> {ann.title}</h3>
                            <p className="text-sm text-text-secondary mt-1">{ann.content}</p>
                            <span className="text-[10px] text-gray-500 block mt-2">{new Date(ann.createdAt).toLocaleDateString('tr-TR')} tarihinde yayınlandı.</span>
                        </div>
                        <div className="flex gap-2">
                            <button onClick={() => startEdit(ann)} className="bg-blue-600/20 text-blue-500 p-2 rounded hover:bg-blue-600 hover:text-white transition-colors"><FaEdit /></button>
                            <button onClick={() => handleDelete(ann._id)} className="bg-red-600/20 text-red-500 p-2 rounded hover:bg-red-600 hover:text-white transition-colors"><FaTrash /></button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ManageAnnouncementsPage;